import { Component, Input } from '@angular/core'

import { environment } from '../../../../../../environments/environment'
import { ToolUseCase } from '../../../interfaces/tool-use-case.interface'

@Component({
  selector: 'app-tool-use-case-card',
  templateUrl: './tool-use-case-card.component.html',
  styleUrls: ['./tool-use-case-card.component.scss']
})
export class ToolUseCaseCardComponent {
  @Input() useCase: ToolUseCase

  storagePath: string = environment.apiCatalogStoragePath
}
